export default __webpack_public_path__ + "static/ACRYLIC SOLID SURFACE - GRANEX-697c1b0dd52263f82e9aa9fef673ae44.webp";